import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { AuthContext } from './AuthContext';

export const AuthProvider = ({children}) => {
   const {
    Auth,
    User,
    role,
    getRole,
    signIn,
    signOut,
    checkAuthentication,
    isAuthenticated
   } =  useAuth();

  return (
    <AuthContext.Provider value={
        {
            Auth,
            User,
            role,
            getRole,
            signIn,
            signOut,
            checkAuthentication,
            isAuthenticated
        }
    }>
        {children}
    </AuthContext.Provider>
  )
}
